import * as React from "react";
const SvgDropDown = props => <svg xmlns="http://www.w3.org/2000/svg" width={15} height={9} fill="currentColor" viewBox="0 0 15 9" {...props}><path d="M13.25 0 7.5 5.595 1.75 0 0 1.703 7.5 9 15 1.703z" /></svg>;
export default SvgDropDown;